<template>
  <b-modal
    :id="id"
    title="History"
    :hide-footer="true"
    size="xl"
    @show="onShow"
  >
    <div class="m-n3">
      <b-overlay :show="!results">
        <div
          v-if="results && results.models && results.models.length"
          class="p-3"
        >
          <analyte-result-table :sample="sample" :results="results" />
        </div>
        <div v-else>
          <b-alert show
            >There are no results for
            <b
              >{{ sample.receiving_id }}-{{ instrument_instance.name }}-{{
                analysis.name
              }}</b
            >,
          </b-alert>
        </div>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import AnalyteResultCollection from "@/collections/lab/AnalyteResultCollection";
import AnalyteResultTable from "@/components/lab/analyte/AnalyteResultTable";

export default {
  name: "ScheduleResultHistoryModel",
  components: { AnalyteResultTable },
  props: {
    id: {
      type: String,
      default: null,
    },
    analysis: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sample: {
      type: Object,
      default: () => null,
    },
    instrument_instance: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      results: null,
    };
  },
  methods: {
    fetch() {
      let context = this;
      let collection = new AnalyteResultCollection();
      collection.getFilter().filterEquals("analysis_id", this.analysis.id);
      collection.getFilter().filterEquals("sample_id", this.sample.id);
      collection
        .getFilter()
        .filterEquals("instrument_instance_id", this.instrument_instance.id);
      return collection.fetch().then(() => {
        return (context.results = collection);
      });
    },
    onShow() {
      this.results = null;
      this.fetch();
    },
  },
};
</script>
